import Vue from 'vue'
import Vuex from 'vuex'
import Settings from './settings.js'
import Notification from './notification.js'
import Spinner from './spinner.js'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        notification: Notification,
        settings: Settings,
        spinner: Spinner,
    },
})